<template>
  <div class="orderApp">
    <main-menu></main-menu>
    <router-view></router-view>
    <delivery />
  </div>
</template>

<script>
import Delivery from "./components/Delivery";
import MainMenu from "./components/MainMenu";
export default {
  name: 'app',
  components: {MainMenu, Delivery},
  computed: {
    cartState () {
      return this.$store.state.cart.checkoutState
    }
  },
  watch: {
    cartState(newValue) {
      if ('completed' == newValue) {
        if ('PS-CC' == this.$store.state.cart.payments[0].method.code) {
          console.log('--------------')
          this.$store.dispatch('finalizeStripePayment').catch(()=>{
            this.$store.commit('setStripeError', 'Failed to register your payment. Please try again or contact our support.')
            this.$router.push('/finalize')
          }).then(()=>{
            this.$router.push('/finalize')
          })
        } else {
          this.$router.push('/finalize')
        }
      }
    }
  }
}
</script>

<style lang="scss">
//  @import "../../mcdoner/public/typo3conf/ext/mcdoner/Resources/Public/Scss/Theme/variables";

</style>
